import React from 'react';
import DisclosureTooltip from '../../../components/Atoms/DisclosureTooltip';
import PostDate from '../../../components/Atoms/PostDate';
import TimeToRead from '../../../components/Atoms/TimeToRead';
import EditorialDisclosure from '../../../components/Atoms/EditorialDisclosure';

import formattedDate from '../../../utilities/formattedDate';
import parseHTML from '../../../utilities/parseHTML';
import sanitize from '../../../utilities/parseHTML/purify';

const articleInfoTransformer = (query) =>
{
    const { eat } = query.post.cdmfields;
    const hasUpdatedDate = !!query.post.cdmfields?.eat?.post_updated_date?.length;
    const readingtime = query.post.cdmfields?.readingtime?.minutes || 0;
    const parsedDate = hasUpdatedDate 
        ? formattedDate(
            sanitize( eat.post_updated_date)
        )
        : formattedDate( 
            sanitize( query.post.date )
        )

    const factChecked = eat?.show_factchecked_tooltip ? 
        <DisclosureTooltip key="DisclosureTooltip"
            content={parseHTML(query.FactCheckedDisclosure?.content || '', ['learningCenter']).parsed} 
        /> : null;

    const edDisclo = query.EdDisclosure?.content ? <EditorialDisclosure 
        label="Disclosure" 
        textModal={parseHTML(query.EdDisclosure?.content, ['learningCenter']).parsed}
        key="EditorialDisclosure" 
    /> : null;

    return [
        <TimeToRead time={sanitize(readingtime.toString())} key="TimeToRead" />,
        <PostDate updateDate={hasUpdatedDate} date={parsedDate} key="PostDate" />,
        factChecked,
        edDisclo
    ]
}
export default articleInfoTransformer;